<template lang="jade">
  section.upload(@click="add")
    .upload__tooltip
      partial(name="tooltip")
    input(type="file"
          v-el:upload
          @change="fileHandler"
          style="display:none"
          multiple)
    .upload__icon
      svg(xmlns="http://www.w3.org/2000/svg" 
          data-name="Layer 1" 
          viewBox="0 0 96 96" x="0px" y="0px")
        polygon(points="31.05 39.16 28.11 36.23 48 16.34 67.89 36.23 64.95 39.16 48 22.21 31.05 39.16")
        rect(x="45.93" y="19.27" width="4.15" height="45.51")
        rect(x="29.58" y="75.51" width="36.83" height="4.15")
    h3.upload__title Add Receipts 
    ul.upload__list(v-if="files.length")
      li.upload__item(v-for="file in files")
        .o-file
          span.o-file__icon
            i.fa.fa-file-text-o 
          span.o-file__name(":title"="file.name") {{ file.name }} 
          span.o-file__size {{ file.size | bytesToSize }}
</template>
<script>
import { Asset } from 'src/services/resources'
import _ from 'lodash'
import { addNotification, removeNotification } from 'src/vuex/actions'
import { workflow, config } from 'src/vuex/getters.js'

const FileData = xs => ({meta: xs, name: xs.name, size: xs.size})

export default {
  data () {
    return {
      uid: this.$parent.uid,
      assetId: 0,
      files: []
    }
  },
  props: {
    fdata: {
      type: Object,
      coerce (x) {
        let [tooltip, upload] = x.content
        return _.assign(x, _.omit(upload, ['type']), {tooltip})
      },
      required: true
    }
  },
  vuex: {
    getters: {
      workflow,
      config
    },
    actions: {
      addNotification,
      removeNotification
    }
  },
  computed: {
    headers () {
      let workflow = _.find(this.workflow, ['uid', this.uid])
      return {
        headers: {
          'X-FORMID': workflow.fid,
          'X-FINGERPRINT': workflow.fingerprint,
          'X-SITEID': this.fdata.siteId || workflow.sid
        }
      }
    }
  },
  filters: {
    bytesToSize (x, decimals) {
      if (x === 0) return x
      let k = 1024
      let dm = decimals || 2
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let i = Math.floor(Math.log(x) / Math.log(k))
      return parseFloat((x / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
  },
  methods: {
    add () {
      this.$els.upload.click()
    },
    clearStorage () {
      this.validate(this.files)
      // sessionStorage.removeItem('assetId')
    },
    fromStorage (assetId) {
      Asset.get({assetId}, this.headers)
           .then(this.fromPairs)
      return parseInt(assetId)
    },
    fromPairs (res) {
      let {current} = res.data.returnValue
      this.$set('files', _.map(_.toPairs(current), xs => {
        let [name, size] = xs
        return {name, size}
      }))
    },
    validate (coll) {
      let validated = this.computedValidate(this.fdata, _.concat(coll, [{}]))
      // if (this.config.inlineErrors && _.gt(this.attempts, 0)) {
      //   this.$set('errors', validated)
      // }
      this.notice('error', validated)
      return _.isNull(validated)
    },
    notice (type, valid) {
      _.isNil(valid) || _.isEmpty(valid)
        ? this.removeNotification(this.fdata.field)
        : this.addNotification({
          type: type,
          msg: valid,
          id: this.fdata.field,
          show: !this.config.inlineErrors
        })
    },
    fileHandler (e) {
      e.stopPropagation()
      e.preventDefault()
      let fileList = e.target.files || e.dataTransfer.files
      let files = _.values(fileList).map(FileData)

      if (this.validate(files)) {
        this.$set('files', _.union(this.files, files))
        this.dispatch()
        Asset.upload(this.params(), this.headers)
      }
    },
    dispatch () {
      if (this.fdata.field) {
        this.$dispatch('fdata::input', {[this.fdata.field]: _.map(this.files, xs => xs.name)})
      }
    },
    params () {
      let data = new FormData()
      let field = this.fdata.field
      data.append('assetId', this.assetId)
      this.files.forEach(f => {
        if (_.has(f, 'meta')) data.append(`${field}[]`, f.meta)
      })
      sessionStorage.setItem('assetId', this.assetId)
      return data
    }
  },
  events: {
    'force::submit': 'clearStorage'
  },
  beforeCompile () {
    this.$options.partials = {tooltip: this.fdata.tooltip.value}
  },
  ready () {
    let assetId = sessionStorage.getItem('assetId')
    this.$set('assetId', (!_.isUndefined(assetId) && !_.isNaN(parseInt(assetId)) ? this.fromStorage(assetId) : this.fdata.assetId))
  }
}
</script>




// WEBPACK FOOTER //
// file.vue?4410f1bc